import { logTypeName } from '@yp/common/core.ts';
import { hasClassType, isAbsent, type ClassType } from '@yp/common/identity.ts';
import { DescriptorCache } from '@yp/common/schema/cache.ts';
import type { Descriptor, RefId, Struct } from '@yp/common/schema/descriptor.ts';
import { converterOf } from '@yp/util.firebase/converter.ts';
import {
  QueryDocumentSnapshot,
  type CollectionReference,
  type DocumentReference,
  type DocumentSnapshot,
  type getDoc as fireGetDoc,
  type getDocs as fireGetDocs,
} from 'firebase/firestore';
import { getDoc, getDocs } from './internal.ts';

export class FirestoreCache extends DescriptorCache {
  constructor(
    private readonly docRef: ClassType<DocumentReference>,
    private readonly collRef: ClassType<CollectionReference>,
    private readonly getDoc: typeof fireGetDoc,
    private readonly getDocs: typeof fireGetDocs,
  ) {
    super();
  }

  protected override doLookup<T extends Struct>(
    desc: Descriptor<T>,
    ref: RefId<T>,
  ): Promise<DocumentSnapshot<T>> {
    if (hasClassType(ref, this.docRef)) {
      let docRef = ref;
      if (isAbsent(docRef.converter)) {
        // TODO: Consider caching these converters?
        docRef = docRef.withConverter(converterOf(desc));
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument
      return getDoc(docRef as any, (r) => this.getDoc(r));
    }
    throw new Error(`${ref.path} is a ${logTypeName(ref)} and not a DocumentReference`);
  }

  protected override doQuery<T extends Struct>(
    desc: Descriptor<T>,
    ref: RefId<T>,
  ): Promise<QueryDocumentSnapshot<T>[]> {
    // collection(getFirestore(), checkPresent(desc.meta.name))
    if (hasClassType(ref, this.collRef)) {
      let collRef = ref;
      if (isAbsent(collRef.converter)) {
        // TODO: Consider caching these converters?
        collRef = collRef.withConverter(converterOf(desc));
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument
      return getDocs(collRef as any, (r) => this.getDocs(r));
    }
    throw new Error(`${ref.path} is a ${logTypeName(ref)} and not a CollectionRefer`);
    // return getDocs(
    //   .withConverter(converterOf(desc)),
    // ).then((qs) => qs.docs);
  }
}
